import React from 'react';
import { Rating } from './rating';
import styles from './detailed-rating.module.scss';

const _DetailedRating = ({
    children,
    className = '',
    onRatingClicked,
    ratingDescriptions = [],
    selectedRating = 0,
    title
}) => {
    const ratingDescriptionExist =
        ratingDescriptions.length > 0 &&
        ratingDescriptions.length >= selectedRating;
    const ratingDescription = ratingDescriptionExist
        ? ratingDescriptions[selectedRating - 1]
        : null;

    return (
        <div className={`${styles.detailedRating} ${className}`}>
            <h5>{title}</h5>
            <Rating
                selectedRating={selectedRating}
                onRatingClicked={onRatingClicked}
            />
            {ratingDescription && (
                <p className="text-gray-600 text-center text-md-left m-0">
                    {ratingDescription}
                </p>
            )}
            {children}
        </div>
    );
};
export const DetailedRating = React.memo(_DetailedRating);
